exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".checkbox-cell{text-align:center !important}\n", "", {"version":3,"sources":["D:/a/1/s/ContainerWeb.WebApp/src/components/shared/checkboxCell/D:/a/1/s/ContainerWeb.WebApp/src/components/shared/checkboxCell/D:/a/1/s/ContainerWeb.WebApp/src/components/shared/checkboxCell/checkbox-cell.scss"],"names":[],"mappings":"AAAA,eACE,4BAA6B,CAAA","file":"checkbox-cell.scss","sourcesContent":[".checkbox-cell {\r\n  text-align: center !important;\r\n\r\n  input {\r\n  }\r\n}\r\n"],"sourceRoot":""}]);

// exports
